import { styled } from "@mui/material";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import { LAYOUT } from "helpers/constants";
import { APP_HEADER_HEIGHT } from "helpers/headerLayout";

export const StyledImg = styled("img")(() => ({
  width: "auto",
  height: 32,
  margin: 2,
}));

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
  showMobileCompanionBar?: boolean;
}

export const StyledAppBar = styled(MuiAppBar)<AppBarProps>`
  transition: ${(props) =>
    props.theme.transitions.create(["margin", "width"], {
      easing: props.theme.transitions.easing.sharp,
      duration: props.theme.transitions.duration.leavingScreen,
    })};
  width: calc(
    100% ${(props) => (props.open ? "- " + LAYOUT.DRAWER_WIDTH + "px" : "")}
  );
  /* Keep header actions below the Android/iOS status bar in standalone PWA. */
  padding-top: env(safe-area-inset-top, 0px);
  height: ${(props) =>
    props.showMobileCompanionBar
      ? `calc(${APP_HEADER_HEIGHT.MOBILE_WITH_COMPANION}px + env(safe-area-inset-top, 0px))`
      : `calc(${APP_HEADER_HEIGHT.MOBILE}px + env(safe-area-inset-top, 0px))`};
  margin-left: ${() => LAYOUT.DRAWER_WIDTH}px;
  justify-content: center;
  background-color: ${(props) => props.theme.palette.primary.main};
  color: ${(props) => props.theme.palette.primary.contrastText} !important;
  ${(props) =>
    props.theme.transitions.create(["margin", "width"], {
      easing: props.theme.transitions.easing.easeOut,
      duration: props.theme.transitions.duration.enteringScreen,
    })};
  & .header-text {
    padding-left: ${(props) => (props.open ? "" : LAYOUT.DRAWER_WIDTH)}px;
  }
  ${(props) => props.theme.breakpoints.up("sm")} {
    height: calc(
      ${APP_HEADER_HEIGHT.DESKTOP}px + env(safe-area-inset-top, 0px)
    );
  }
  @media (max-width: 900px) {
    height: ${(props) =>
      props.showMobileCompanionBar
        ? `calc(${APP_HEADER_HEIGHT.MOBILE_WITH_COMPANION}px + env(safe-area-inset-top, 0px))`
        : `calc(${APP_HEADER_HEIGHT.MOBILE}px + env(safe-area-inset-top, 0px))`};
    width: calc(
      100% ${(props) => (props.open ? "- " + LAYOUT.DRAWER_WIDTH + "px" : "")}
    );
  }
`;

export const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "center",
}));
